module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-02-16 at 21.42.49 - Copy.483b739d.jpeg";